/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from 'redux/reducers/clonotypes/initialState';
var qcFinished = produce(function () {
  return initialState;
}, initialState);
export default qcFinished;